import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/api/client";

export default function LoginPage() {
  const { user, checked, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (checked && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Não foi possível iniciar sessão.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="page-login" className="min-h-screen flex items-center justify-center bg-[#FBFBF9] p-6">
      <div className="w-full max-w-md card-soft p-10">
        <div className="flex items-center">
          <img src="/logo.png" alt="casa no porto" className="h-9 w-auto" />
        </div>
        <h1 className="mt-8 font-display text-3xl text-stone-900">Entrar no CMS</h1>
        <p className="mt-2 text-sm text-stone-600">Acesso reservado à Zélia Silva.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">{error}</div>}
          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-primary w-full">{busy ? "A entrar..." : "Entrar"}</button>
        </form>
      </div>
    </div>
  );
}
